module.exports = __webpack_public_path__ + "media/images/main_slider/SI-BUIS-b8a13fba284faad3bb15469f54b94b29.png";